import { createAction, createSlice } from '@reduxjs/toolkit';
import { Reducers } from '@sda/enums/store';
import { extractSharedActions } from '@sda/utils/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { Affiliate } from '@sda/interfaces/affiliate';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const startAddShowAffiliateLink = createAction<string>(`${Reducers.AFFILIATES}/startAddShowAffiliateLink`);
export const startDeleteAffiliateLink = createAction<string>(`${Reducers.AFFILIATES}/startDeleteAffiliateLink`);
export const startAffiliateLinkImpression = createAction<{ showId: string, affiliateLinkSource: string }>(`${Reducers.AFFILIATES}/startAffiliateLinkImpression`);

/**
 * data fetching
 */
export const startFetchShowAffiliates = createAction<string>(`${Reducers.AFFILIATES}/startFetchShowAffiliates`);
export const unsubscribeShowAffiliates = createAction<string>(`${Reducers.AFFILIATES}/unsubscribeShowAffiliates`);

export const affiliateAdapter = createEntityAdapter<Affiliate & FetchDataType>({
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

const affiliatesSlice = createSlice({
  initialState: affiliateAdapter.getInitialState(),
  name: Reducers.AFFILIATES,
  reducers: {
    ...extractSharedActions(affiliateAdapter),
  },
});

export const {
  removeOne: removeAffiliate, addOne: addAffiliate,
} = affiliatesSlice.actions;

export default affiliatesSlice.reducer;
